import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useCategoryOptions(categories: readonly string[]) {
  const { t } = useTranslation('settings');

  return useMemo(
    () => [
      { label: t('categories.all'), value: 'ALL' },
      ...categories.map((category) => ({
        label: t(`categories.${category}`, { defaultValue: category }),
        value: category,
      })),
    ],
    [categories, t],
  );
}
